import React from "react";

type GdgocModalProps = {
  open: boolean;
  onCancel: () => void;
  onProceed: () => void;
};

const GdgocModal: React.FC<GdgocModalProps> = ({
  open,
  onCancel,
  onProceed,
}) => {
  if (!open) return null;

  return (
    <>
      <div
        onClick={onCancel}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.6)",
          zIndex: 3000,
        }}
      />

      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 3001,
          width: "90%",
          maxWidth: "560px",
        }}
      >
        <div
          className="p-4 rounded"
          style={{
            background: "#0b0d12",
            color: "#fff",
            boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
          }}
        >
          <h5 className="mb-2">Leaving this site</h5>
          <p className="mb-3">
            You will be redirected to the GDGOC website. Do you want to
            continue?
          </p>

          <div className="d-flex justify-content-end" style={{ gap: "0.5rem" }}>
            <button className="btn btn-outline-light" onClick={onCancel}>
              Cancel
            </button>
            <button className="btn btn-info" onClick={onProceed}>
              Proceed
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default GdgocModal;
